import { useNavigate, useRouteError } from 'react-router-dom';
import {
  HomeOutlined,
  ReloadOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { Button, Space, Typography } from 'antd';
import { AxiosError } from 'axios';

const { Title, Paragraph } = Typography;

function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  const getErrorInfo = () => {
    if (error instanceof AxiosError) {
      return {
        status: error.response?.status || 'Error',
        message:
          error.response?.data?.message ||
          error.response?.data ||
          '서버 오류가 발생했습니다.',
        subMessage: '잠시 후 다시 시도해주세요.',
      };
    }

    if (error && typeof error === 'object' && 'status' in error) {
      const { status } = error as any;
      switch (status) {
        case 404:
          return {
            message: '페이지를 찾을 수 없습니다.',
            subMessage: '요청하신 페이지가 존재하지 않습니다.',
          };
        case 403:
          return {
            message: '접근 권한이 없습니다.',
            subMessage: '이 페이지에 접근할 권한이 없습니다.',
          };
        case 500:
          return {
            message: '서버 오류가 발생했습니다.',
            subMessage: '잠시 후 다시 시도해주세요.',
          };
        default:
          return {
            message: '오류가 발생했습니다.',
            subMessage: '잠시 후 다시 시도해주세요.',
          };
      }
    }

    return {
      message: '오류가 발생했습니다.',
      subMessage: '잠시 후 다시 시도해주세요.',
    };
  };

  const errorInfo = getErrorInfo();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className='min-h-screen flex items-center justify-center bg-gray-50'>
      <div className='w-full max-w-md mx-4'>
        <div className='bg-white rounded-lg border border-gray-200 p-8'>
          <div className='flex justify-center mb-6'>
            <div className='w-16 h-16 bg-red-50 rounded-full flex items-center justify-center'>
              <WarningOutlined className='text-2xl text-red-500' />
            </div>
          </div>

          <div className='text-center space-y-6'>
            <Title level={3} className='!text-gray-900 !font-semibold !mt-8'>
              {errorInfo.message}
            </Title>

            <Paragraph className='!text-gray-600 !mb-6 !mt-2'>
              {errorInfo.subMessage}
            </Paragraph>

            <Space size='middle' className='w-full justify-center'>
              <Button
                type='primary'
                icon={<HomeOutlined />}
                onClick={handleGoHome}
                className='!bg-punta-orange hover:!bg-punta-light !border-punta-orange'
              >
                홈으로
              </Button>
              <Button icon={<ReloadOutlined />} onClick={handleRefresh}>
                새로고침
              </Button>
            </Space>
          </div>

          <div className='mt-6 pt-4 border-t border-gray-100'>
            <div className='text-center'>
              <Typography.Text type='secondary' className='text-sm'>
                문제가 지속되면 관리자에게 문의해주세요
              </Typography.Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
